import React, { Component, Fragment } from 'react'
import { Container, UncontrolledTooltip, Row, Col, Badge } from 'reactstrap'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import SectionMain from '~/components/pages/Section'
import Title from '~/components/Title'
import Button from '~/components/Button'

import { LogosRow } from '~/components/pages/index/Logos'

const PricingContainer = styled.div`
  margin: 0 auto;
  max-width: 900px;
`

const PricingFeatures = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    align-items: flex-end;
    flex-direction: row;
    margin: 0 auto;
    width: 100%;
  }
`

const PricingFeaturesCard = styled.section`
  background-color: var(--c-dark);
  padding: 1rem;
  width: calc(100% - 30px);

  @media screen and (min-width: 768px) {
    width: 33%;
  }

  &:nth-child(2) {
    background-color: var(--c-brand);
    color: white;

    li {
      font-size: 16px;

      &::after {
        border-bottom: 1px dashed var(--c-brand-dark);
      }
    }
  }

  ul {
    padding: 0;

    @media screen and (min-width: 768px) {
      margin: 0 0 0 1rem;
    }
  }

  li {
    display: table;
    font-size: 14px;
    list-style: none;
    margin: 1rem auto;
    position: relative;

    path {
      fill: currentColor;
    }

    &::after {
      content: '';
      border-bottom: 1px dashed #555;
      bottom: 0;
      display: block;
      left: 0;
      right: 0;
      position: absolute;
    }

    @media screen and (min-width: 768px) {
      margin: 0 0 1rem 0;
    }
  }
`

const PricingFeaturesTitle = styled.div`
  margin-bottom: 1rem;
  text-align: center;

  span {
    background: var(--c-brand-dark);
    color: white;
    font-size: 14px;
    font-weight: 600;
    padding: 0.25em 1em;
  }
`

const InfoIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 16h2v-2H9v2zm1-16C4.477 0 0 4.477 0 10A10 10 0 1 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14a4 4 0 0 0-4 4h2a2 2 0 1 1 4 0c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4z"
      fill="#4A4A4A"
      fill-rule="nonzero"
    />
  </svg>
)

export default class Pricing extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Pricing</title>
          <meta
            name="description"
            content="Whether you are a developer, digital agency or a big enterprise, Botpress has a plan that fits your requirements."
          />
        </Helmet>
        <SectionMain backgroundColor="dark">
          <Container>
            <Title className="mb-4">Pricing</Title>
            <p className="lead text-center">
              Whether you are a developer, digital agency or a big enterprise,
              <span className="is-block">
                Botpress has a plan that fits your requirements.
              </span>
            </p>
          </Container>
        </SectionMain>
        <SectionMain backgroundColor="dark" className="pt-0">
          <PricingContainer>
            <PricingFeatures>
              <PricingFeaturesCard>
                <PricingFeaturesTitle>
                  <h4>Community</h4>
                  <span>40,000+ Developers</span>
                </PricingFeaturesTitle>
                <ul>
                  <li>
                    <span id="TooltipBotpressNLU">
                      Botpress NLU <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipBotpressNLU"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      On-prem NLU engine that ships with world-class IC (Intent
                      Classification) and LID (Language Identification).
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipVisualFlowEditor">
                      Visual Flow Editor <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipVisualFlowEditor"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      User-friendly drag-and-drop interface to design
                      conversational flows.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipDialogManagement">
                      Dialog Management <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipDialogManagement"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Flexible DM (Dialog Manager) with state persistence,
                      actions, timeouts, SDK and more.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipBotCMS">
                      Bot CMS <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipBotCMS"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Manage all outgoing content in one single place via the
                      GUI or SDK.
                    </UncontrolledTooltip>
                  </li>
                  {/* <li>
                    <span id="TooltipMessagingChannels">
                      Messaging Channels <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipMessagingChannels"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Includes Facebook Messenger, Telegram, Botpress Webchat,
                      Microsoft Teams, Slack, Skype and more.
                    </UncontrolledTooltip>
                  </li> */}
                  {/* <li>
                    <span id="TooltipCommunityModules">
                      Community Modules <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipCommunityModules"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Modules created by the Botpress Team and the open-source
                      community.
                    </UncontrolledTooltip>
                  </li> */}
                </ul>
                <Button to="/download" fullwidth>
                  Download Free
                </Button>
              </PricingFeaturesCard>
              <PricingFeaturesCard>
                <PricingFeaturesTitle>
                  <h4>Pro</h4>
                  <span>New Plan</span>
                </PricingFeaturesTitle>
                <ul>
                  <li>
                    <span id="TooltipUnlimitedBots">
                      Unlimited Bots <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipUnlimitedBots"
                      delay={{ show: 100, hide: 30 }}
                    >
                      You can build as many bots as you want on the same server.
                      No re-deployment needed.
                    </UncontrolledTooltip>
                  </li>
                  {/* <li>
                    <span id="TooltipUnlimitedTeams">
                      Unlimited Teams <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipUnlimitedTeams"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Teams allows you to separate your projects by people and
                      bots.
                    </UncontrolledTooltip>
                  </li> */}

                  <li>
                    <span id="TooltipMultipleAdmins">
                      Unlimited Admins <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipMultipleAdmins"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Create and manage bot administrators, each with their own
                      credentials.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipWhiteLabelInterface">
                      White-Label Interface <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipWhiteLabelInterface"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Change how Botpress looks, adapt it to your brand and
                      colors!
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipRBAC">
                      RBAC <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipRBAC"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Role-Based Access Control (RBAC) allows you to decide
                      which admin can do what.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipHighPerformance">
                      High-Availability <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipHighPerformance"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Achieve High-Availability by adding more nodes to your
                      Botpress cluster.
                      <sup>1</sup>.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipHighPerformance">
                      Increased Performances <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipHighPerformance"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Add more processing power by increasing the number of
                      nodes in your cluster.
                      <sup>1</sup>.
                    </UncontrolledTooltip>
                  </li>
                  {/* <li>
                    <span id="TooltipTestingFramework">
                      Testing Framework
                      <Badge className="ml-1 mr-1" color="primary">
                        Soon
                      </Badge>
                      <InfoIcon />
                    </span>

                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipTestingFramework"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Continuous testing of your bot scenarios, making sure that
                      it keeps running as it should at all time.
                    </UncontrolledTooltip>
                  </li> */}
                  <li>
                    <span id="TooltipStandardSupport">
                      Standard Support <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipStandardSupport"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Email and Community Forum. 72 hours response
                      <sup>2</sup>.
                    </UncontrolledTooltip>
                  </li>
                </ul>
                <Button
                  disabled={false}
                  fullwidth
                  color="var(--c-brand)"
                  backgroundColor="var(--c-secondary)"
                  to="https://botpress.typeform.com/to/QaznSq"
                >
                  <strong>
                    Contact Us
                  </strong>
                </Button>
              </PricingFeaturesCard>
              <PricingFeaturesCard>
                <PricingFeaturesTitle>
                  <h4>Custom</h4>
                  <span>Drop us a line</span>
                </PricingFeaturesTitle>
                <ul>
                  <li>
                    <span id="TooltipFeatureSponsorship">
                      Feature Sponsorship <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipFeatureSponsorship"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      You want to get an elligible feature that is scheduled on
                      our roadmap faster? Sponsor the feature at a fixed,
                      predictable and honest cost
                      <sup>3</sup>.
                    </UncontrolledTooltip>
                  </li>
                  {/* <li>
                    <span id="TooltipDeployPipeline">
                      Deploy Pipeline <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipDeployPipeline"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Create multiple environments (dev, staging, production)
                      for your bots.
                    </UncontrolledTooltip>
                  </li> */}
                  {/* <li>
                    <span id="TooltipSSO">
                      SSO with SAML <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipSSO"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Configure SAML or LDAP to control both administrative
                      access (dashboard) and chatbot users (messaging channels).
                    </UncontrolledTooltip>
                  </li> */}

                  <li>
                    <span id="TooltipGoldSupport">
                      Gold Support <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipGoldSupport"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Priority Email. Same-day response. 7-day bug fixes
                      <sup>2</sup>.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipContracts">
                      Custom Contract <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipContracts"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      We can sign your contract instead of you using our EULA.
                    </UncontrolledTooltip>
                  </li>
                  <li>
                    <span id="TooltipPartnership">
                      Strategic Partnership <InfoIcon />
                    </span>
                    <UncontrolledTooltip
                      placement="right"
                      target="TooltipPartnership"
                      className="tooltip--light"
                      delay={{ show: 100, hide: 30 }}
                    >
                      Thinking of a great win/win partnership opportunity? We'd
                      love to hear about it!
                    </UncontrolledTooltip>
                  </li>
                </ul>
                <Button to="https://botpress.typeform.com/to/QaznSq" fullwidth>
                  Contact Us
                </Button>
              </PricingFeaturesCard>
            </PricingFeatures>
          </PricingContainer>
        </SectionMain>
        <SectionMain
          backgroundColor="dark"
          className="pt-0 m-0"
          size="large"
          textAlign="center"
        >
          <Container style={{ opacity: 0.5 }}>
            <LogosRow number={6} />
          </Container>
        </SectionMain>

        <SectionMain backgroundColor="dark" className="pt-0">
          <Container>
            <Row>
              <Col xs={10}>
                <p className="text-muted small m-0">
                  <sup>1</sup> We run performance benchmarks on a regular basis,{' '}
                  <a href="mailto:support@botpress.io">contact us</a> to speak
                  about scalability concerns and advisory.
                </p>
                <p className="text-muted small m-0">
                  <sup>2</sup> Business hours from 9AM to 4PM EST. Maximum of 8
                  incidents per month. Custom SLA available via Partners.
                </p>
                <p className="text-muted small m-0">
                  <sup>3</sup> Feature must be elligible and pre-approved by us.
                  Please <a href="mailto:support@botpress.io">contact us</a> to
                  discuss. Fixed daily rate.
                </p>
              </Col>
            </Row>
          </Container>
        </SectionMain>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/pricing.js